<template>
  <div
    :class="[
      { 'as-statistic-home': isHomePage },
      `as-parent-statics as-parent-statics-${siteName}`,
    ]"
  >
    <div v-if="isShowTab"
      class="as-nav-tabs-btn as-nav-tabs-btn__border"
      :class="`as-nav-tabs-btn-${siteName}`"
    >
      <div
        class="as-nav-item"
        v-for="tab of statistics"
        :key="tab.id"
        :class="{ active: activeTab === tab.type }"
        @click="activeTab = tab.type"
      >
        <span class="as-extra-item"></span>
        {{ getTabLabel(tab.type) }}
      </div>
    </div>
    <div v-else>
      <StatisticsItem
        :statistics="dataDefault"
        :match="match"
        :isHomePage="isHomePage"
        :isDefault="true"
      />
    </div>
    <!-- <NoData v-else /> -->

    <div v-if="isShowTab" class="as-tab-content">
      <StatisticsItem
        v-for="statistic in statistics"
        :key="statistic?.id"
        v-show="activeTab === statistic.type"
        :statistics="statistic"
        :match="match"
        :isHomePage="isHomePage"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, ref, computed, watch } from "vue";
import type { IStatistics, IMatch } from "~src/interfaces/basketball";
import StatisticsItem from "~src/components/statistics/basketball/StatisticsItem.vue";
import {
  getProcessedStats,
  initializeData,
} from "~src/helpers/basketball/index";
import { usecommonStore } from "~src/stores/CommonStore";
const commonStore = usecommonStore();

interface IProps {
  statistics: IStatistics[];
  match: IMatch;
  isHomePage: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  isHomePage: false,
});

const siteName = computed(() => commonStore.getSiteName);
const dataDefault = initializeData();
const activeTab = ref(0);

const statisticAll = computed<any>(() => {
  const data = props.statistics[0];
  return data;
});

const isShowTab = computed(() => {
  if (!statisticAll.value || statisticAll.value.type === 10) {
    return false;
  }

  const stats = getProcessedStats(props.match, statisticAll.value, false);

  return stats.length > 0;
});

const getTabLabel = (type: number | string): string | null | undefined => {
  switch (type) {
    case 0:
      return "Tất cả";
    case 2:
      return "Hiệp 1";
    case 4:
      return "Hiệp 2";
    case 6:
      return "Hiệp 3";
    case 8:
      return "Hiệp 4";
    case 9:
      return "OT";
    default:
      return undefined;
  }
};
</script>

<script lang="ts">
export default {};
</script>
